export const VerifyPhoneNumber = (phoneNumber) => {
	const phoneRegExp =
		/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

	if (!phoneNumber) {
		return 'Please enter a valid phone number';
	} else if (phoneNumber.length < 10) {
		return 'Phone number must be 10 numbers long';
	} else if (phoneRegExp.test(phoneNumber)) {
		return true;
	} else {
		return 'Invalid Phone Number';
	}
};

export const VerifyFirstName = (firstName) => {
	var reg = /^[a-z]+$/i;
	var name = firstName;

	if (!firstName) {
		return 'Please enter a valid first name';
	} else if (name != '' && reg.test(name)) {
		return true;
	} else {
		return 'Please enter a valid first name';
	}
};

export const VerifyLastName = (lastName) => {
	var reg = /^[a-z]+$/i;
	var name = lastName;

	if (!lastName) {
		return 'Please enter a valid last name';
	} else if (name != '' && reg.test(name)) {
		return true;
	} else {
		return 'Please enter a valid last name';
	}
};

export const VerifyPasswords = (password, vpassword) => {
	if (!password) {
		return 'Please enter a valid password';
	} else if (password.length < 4) {
		return 'Password must be at least 4 characters long';
	} else if (password.length > 20) {
		return 'Password must not exceed 20 characters';
	} else if (password !== vpassword) {
		return 'Password fields must match';
	} else {
		return true;
	}
};

export const VerifyPassword = (password) => {
	if (!password) {
		return 'Please enter a valid password';
	} else if (password.length > 20) {
		return 'Password must not exceed 20 characters';
	} else {
		return true;
	}
};

export const VerifySMSPin = (pin) => {
	let isNum = /^\d+$/.test(pin);
	if (isNum) {
		if (pin.length === 4) {
			return true;
		} else {
			return 'Please enter valid pin';
		}
	} else {
		return 'Please enter valid pin';
	}
};

export const VerifyPartyName = (partyName) => {
	if (!partyName) {
		return 'Please enter a valid party name';
	} else if (partyName.length > 30) {
		return 'Party name must not exceed 30 characters';
	} else {
		return true;
	}
};

export const VerifyStartDate = (date) => {
	let startDate = new Date(date);
	let currentDate = new Date();
	if (!date) {
		return 'Please enter a valid start date';
	} else if (startDate < currentDate) {
		return 'Start date must be after current date';
	} else {
		return true;
	}
};

export const VerifyDuration = (duration) => {
	if (!duration) {
		return 'Please enter a valid duration';
	} else {
		return true;
	}
};

export const VerifyTime = (time) => {
	var re = /^(0?[0-9]|1[0-9]|2[0-3]):[0-9]+$/;
	var isValid = re.test(time);

	if (isValid === true) {
		return true;
	} else {
		return 'Please enter a valid time';
	}
};

export const VerifyPartyImage = (image) => {
	if (!image) {
		return 'Please enter a valid party photo';
	} else {
		return true;
	}
};

export const VerifyBio = (description) => {
	if (!description) {
		return 'Please enter a valid bio';
	} else if (description?.length > 300) {
		return 'Bio must not exceed 300 characeters';
	} else {
		return true;
	}
};

export const VerifyEventName = (eventName) => {
	//TODO: Should event names be unique
	if (!eventName) {
		return 'Please enter a valid event name';
	} else if (eventName.length > 40) {
		return 'Event name must be less than 40 characeters';
	} else {
		return true;
	}
};
